import './ViewSettings.css';
import React from "react";
import triangle from '../assets/images/triangle.svg';

function ViewSettings(props)  {

        return (
            <div className="modifyView">
                {!props.expandedViewSettings &&
                    <div onClick={() => props.setExpandedViewSettings(true)}>
                        <img className="triangleImage leftTriangle" src={triangle} alt="triangle" />
                        <img className="triangleImage rightTriangle" src={triangle} alt="triangle" />
                        <p className="modifyViewText"> modify view</p>
                    </div>
                }
                {props.expandedViewSettings &&
                <div>
                        <div onClick={() => props.setExpandedViewSettings(false)}>
                            <img className="triangleImage leftTriangle flippedTriangle" src={triangle} alt="triangle" />
                            <img className="triangleImage rightTriangle flippedTriangle" src={triangle} alt="triangle" />
                            <p className="modifyViewText"> modify view</p>
                        </div>
                        <p className="filterHeader">sort noodles by:</p>
                        <div style={{display: 'flex', justifyContent: 'center'}} >
                            <p onClick={() => props.setSelectedSort("default")} className={props.selectedSort === "default" ? "filterOption filterOptionSelected" : "filterOption"}>INF default</p>
                            {/* <p onClick={() => props.setSelectedSort("flavor")} className={props.selectedSort === "flavor" ? "filterOption filterOptionSelected" : "filterOption"}>flavor</p> */}
                            <p onClick={() => props.setSelectedSort("country")} className={props.selectedSort === "country" ? "filterOption filterOptionSelected" : "filterOption"}>country</p>
                            <p onClick={() => props.setSelectedSort("spice")} className={props.selectedSort === "spice" ? "filterOption filterOptionSelected" : "filterOption"}>spice</p>
                        </div>
                        {/* <p className="filterHeader">filter noodles by:</p> */}
                </div>
                }
            </div>
        )
}

export default ViewSettings;